<!-- <button id="th" (click)="setActiveLang('th')">TH</button>
<button id="en" (click)="setActiveLang('en')">EN</button> -->
<div class="container">
  <web-di-ld-calculation-menu
    (click)="onNavigateToCalculation()"
  ></web-di-ld-calculation-menu>
  <div *ngIf="loanProductList && loanProductList.length > 0">
    <div class="loan-title">
      {{ 'loanProductShelf.title' | transloco }}
    </div>
    <div class="p-grid">
      <ng-container *ngFor="let product of loanProductList">
        <div class="p-col-6">
          <web-di-ld-card-product-shelf
            [productDetail]="product"
            (click)="onNavigateToProduct(product)"
          >
          </web-di-ld-card-product-shelf>
        </div>
      </ng-container>
    </div>
    <div class="information">
      <web-di-ld-contact-information
        (onCall)="onCall()"
      ></web-di-ld-contact-information>
    </div>
  </div>
  <div
    *ngIf="
      !(uiLoadingService.isLoading$ | async) && loanProductList?.length === 0
    "
  >
    <img src="/assets/images/img_vayu_empty_loan.png" alt="" />
  </div>
</div>
